import React from 'react'
import { I18n } from 'react-redux-i18n';
import Alert from '../../shared/components/alerts/Alert';
import FormButtons from "../../shared/components/others/formButtons/FormButtons";
import DataTable from './../../shared/components/table/DataTable';
import InterfacesPageContainer from "../../interfaces/containers/InterfacesPageContainer";
import GoogleMap from "../../shared/components/maps/GoogleMap";
import InfoBoxes from "../../shared/components/others/InfoBoxes";
import StringUtils from "../../shared/utils/StringUtils";
import _ from "../../shared/utils/ObjectUtils";
import UserHasPermission, { appModules, modulesActions } from '../../roles/components/UserHasPermission';

const TerminalViewForm = ({
    terminalId,
    profile,
    entity,
    allowAutoProvisioning,
    keepAliveTime,
    status,
    lastCommunication,
    location: {
        value: {
            latitude,
            longitude,
        } = {}
    },
    online,
    alert,
    editMode,
    viewMode,
    entityWithName,
    handleBackClick,
    handleEditClick,
    handleDeleteClick,
    history,
}) => {
    const columns = [{
        Header: I18n.t("terminals.smallForm.description"),
        accessor: "Description",
        sortable: false
    }, {
        Header: I18n.t("terminals.smallForm.value"),
        accessor: "Value",
        sortable: false
    }];

    const entityName = entityWithName ? entityWithName.label : entity.value;

    const boxes = [{
        data: status.value,
        header: I18n.t("terminals.form.status.label")
    }, {
        data: lastCommunication.value,
        header: I18n.t("terminals.form.lastCommunication.label")
    }, {
        data: online ? online.value ? "Online" : "Offline" : "",
        header: I18n.t("terminals.form.connectionState.label"),
        additionalStyles: online ? online.value ? { color: "green" } : { color: "red" } : { color: "gray" }
    }];

    const data = [{
        "Description": I18n.t("terminals.list.profile"),
        "Value": StringUtils.stringNormalize(profile.value)
    }, {
        "Description": I18n.t("terminals.list.entity"),
        "Value": entityName
    }, {
        "Description": I18n.t("terminals.list.keepAliveTimeMinutes"),
        "Value": keepAliveTime.value
    }, {
        "Description": I18n.t("terminals.list.allowAutoProvisioning"),
        "Value": allowAutoProvisioning.value ? I18n.t("terminals.allowAutoProvisioning.yes") : I18n.t("terminals.allowAutoProvisioning.no")
    }];

    return <div>
        <div>
            <Alert
                {...alert}
            />
            <div className="info-boxes-container">
                <InfoBoxes
                    data={boxes}
                />
                <div className="form-options-row">
                    <FormButtons
                        editMode={editMode}
                        viewMode={viewMode}
                        handleBackClick={handleBackClick}
                        handleEditClick={handleEditClick}
                        handleDeleteClick={handleDeleteClick}
                        appModule={appModules.TERMINAL}
                    />
                </div>
            </div>
        </div>
        <div>
            <div className={"terminal-form-details-box-header"}>
                {I18n.t("terminals.page.header")}
            </div>
            {terminalId &&
                <UserHasPermission
                    appModule={appModules.INTERFACE}
                    action={modulesActions.READ}
                >
                    <InterfacesPageContainer
                        externalPageSize={3}
                        suppressSearchForm={false}
                        terminalParentEntity={entity}
                        terminalId={terminalId.value}
                        history={history}
                    />
                </UserHasPermission>
            }
        </div>
        <div className={"terminal-form-details-row"}>
            <div className={"terminal-form-details-box"} style={{ marginRight: "1rem" }}>
                <div className={"terminal-form-details-box-header"}>
                    {I18n.t("terminals.smallForm.title")}
                </div>
                <div className={"terminal-form-details-box-body"}>
                    <DataTable
                        //State dependent
                        data={data}
                        hasHeader={false}
                        pageSizeOptions={[10, 20, 50]}

                        //State independent / Configuration
                        columns={columns}
                        hasStatusBar={false}
                    />
                </div>
            </div>
            <div className={"terminal-form-details-box"} style={{ marginLeft: "1rem" }}>
                <div className={"terminal-form-details-box-header"}>
                    {I18n.t("terminals.list.location")}
                </div>
                <div className={"terminal-form-details-box-body"}>
                    {
                        !_.isNil(latitude) && !_.isNil(longitude) &&
                        <GoogleMap
                            lat={parseFloat(latitude)}
                            lng={parseFloat(longitude)}
                            zoom={15}
                        />
                    }
                </div>
            </div>
        </div>
    </div>
};

export default TerminalViewForm;